import * as React from 'react';
import { AvenyContextConsumer } from '../../Features/AvenyContext';

interface IProps {
  children: React.ReactNode;
}

const OnlyInSingleRoutineMode: React.FC<
  React.PropsWithChildren<IProps>
> = props => (
  <AvenyContextConsumer>
    {avenyContext =>
      avenyContext.singleRoutineMode.enabled ? props.children : null
    }
  </AvenyContextConsumer>
);

export default OnlyInSingleRoutineMode;
